export default __webpack_public_path__ + "static/media/trash-can-lid.f4b3c524.png";